const numberFormatter = new Intl.NumberFormat("es-AR");

const currencyFormatter = new Intl.NumberFormat("es-AR", {
  currency: "ARS",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: "currency"
});

export function formatNumber(value: number | null | undefined): string {
  return numberFormatter.format(value ?? 0);
}

export function formatCurrency(value: number | null | undefined): string {
  return currencyFormatter.format(value ?? 0);
}

export function formatNumericText(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") {
    return "0";
  }

  const normalizedValue = typeof value === "number" ? value : Number(value.replace(/\./g, ""));

  if (!Number.isFinite(normalizedValue)) {
    return String(value);
  }

  return formatNumber(normalizedValue);
}
